import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCardsText, IDiscoveryPhaseTypesSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'

interface IDiscoveryPhaseTypesSectionProps {
    section: IDiscoveryPhaseTypesSection;
}

const DiscoveryPhaseTypesSectionComponent = ({ section }: IDiscoveryPhaseTypesSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_light}`}>
            <div className={`${template.container} ${template.container_phaseType}`}>
                <h2 className={template.block_large__title}>
                    {section.title}
                </h2>
                <div className={`${template.types__block}`}>
                    <div className={`${template.types__textblock} ${style.block}`}>
                        {
                            section.cards.map((item: IDiscoveryCardsText, index: number) => {
                                return (
                                    <div key={index} className={`${template.types__block__item} ${style.block__item}`}>
                                        <div className={template.types__block__title}>
                                            {item.title}
                                        </div>
                                        <div className={template.types__block__text}>
                                            {item.text}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={`${template.introduce__image}`}>
                        <Image src={section.iconSrc} layout={'fill'} alt={section.title} />
                    </div>
                </div>
            </div>
        </section >
    )
}

export default DiscoveryPhaseTypesSectionComponent;